import { render, staticRenderFns } from "./projects-attachments.vue?vue&type=template&id=a252c914&scoped=true&"
import script from "./projects-attachments.vue?vue&type=script&lang=js&"
export * from "./projects-attachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a252c914",
  null
  
)

export default component.exports